import { createContext, useContext } from "react";
import { Product } from "./types";

type Dispatcher = (product: Product) => void;
const ModalDispatcherContext = createContext<Dispatcher>(() => undefined);

const useModalDispatcher = () => useContext(ModalDispatcherContext);

export { ModalDispatcherContext, useModalDispatcher };
